import { useState } from "react";
import { toast } from "sonner";
import { api, formatError, useApi } from "@/lib/api";
import { useAuth } from "./AuthContext";
import { AdminTitle, AInput, ASelect, Table } from "./AdminUi";

const EMPTY = { name: "", email: "", password: "", role: "editor" };

export default function AdminUsers() {
  const { user } = useAuth();
  const { data, reload } = useApi("/admin/users");
  const [f, setF] = useState(EMPTY);
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/users", f); toast.success("Account created"); setF(EMPTY); reload(); } catch (err) { toast.error(formatError(err)); }
  };
  const remove = async (u) => {
    if (!window.confirm(`Remove ${u.email}?`)) return;
    try { await api.delete(`/admin/users/${u.id}`); toast.success("Account removed"); reload(); } catch (err) { toast.error(formatError(err)); }
  };
  return (
    <div data-testid="admin-users">
      <AdminTitle title="Team">Editors can manage content and the directory. Administrators can also view enquiries, the audit log and team accounts. There is no public sign-up.</AdminTitle>
      <form onSubmit={create} className="card-soft !bg-white p-5 grid gap-4 md:grid-cols-[1fr_1.3fr_1fr_0.8fr_auto] items-end mb-6" data-testid="user-create-form">
        <AInput id="user-name" label="Name" value={f.name} onChange={set("name")} required />
        <AInput id="user-email" label="Email" type="email" value={f.email} onChange={set("email")} required />
        <AInput id="user-password" label="Temporary password" type="password" hint="At least 10 characters" value={f.password} onChange={set("password")} required minLength={10} />
        <ASelect id="user-role" label="Role" value={f.role} onChange={set("role")} options={[["editor", "Editor"], ["admin", "Administrator"]]} />
        <button type="submit" className="btn-primary" data-testid="user-create-button">Add</button>
      </form>
      <Table head={["Name", "Email", "Role", "Actions"]} testId="users-table">
        {(data || []).map((u) => (
          <tr key={u.id}>
            <td className="px-4 py-3">{u.name}</td><td className="px-4 py-3">{u.email}</td><td className="px-4 py-3 capitalize">{u.role}</td>
            <td className="px-4 py-3">{u.id !== user.id && <button className="btn-ghost !text-clay-dark" onClick={() => remove(u)} data-testid={`user-delete-${u.email}`}>Remove</button>}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
